import { Account } from '../../components/Account/accountApi'

export const canAccessSetup = (currentUser: Account | undefined): boolean => {
  return currentUser?.roles?.includes('Administrator') ?? false
}
